import { Scene } from 'phaser'
import { store } from '@/store/store'

function sendDataStore(payload) {
  store.dispatch('saveData', {game: 'tower', data: payload})
}

export default class PlayScene extends Scene {
  constructor () {
    super({ key: 'EndScene' })
  }
  init (data) {
    this.playTime = data.time
    this.playMoves = data.moves
  }
  
  create () {
    this.puzzleGameData = {
      time: this.playTime,
      complete: true,
      moves: this.playMoves
    }
    sendDataStore(this.puzzleGameData)
  }
}
